/**
 * Shared step numbering for the onboarding orchestrators, so the two flows
 * (practitioner / instructor) can't drift out of sync.
 *
 * Step 1 is sign-up (outside onboarding); onboarding renders step 2
 * (complete profile) and step 3 (benefits for practitioners / agenda for
 * instructors) out of a 3-step progress bar.
 */
export const ONBOARDING_STEPS = {
  COMPLETE_PROFILE: 2,
  FINAL: 3,
} as const;

export const ONBOARDING_TOTAL_STEPS = 3;
